var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"size":"medium"},on:{"click":_vm.start}},[_vm._v("Sequential edit")])}
var staticRenderFns = []

export { render, staticRenderFns }